export default "__VITE_ASSET__BgY1nrEP__"